var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOutlineEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6667 11.6667C33.6667 10.2 32.4667 9 31 9H9.66667C8.2 9 7 10.2 7 11.6667V27.6667C7 29.1333 8.2 30.3333 9.66667 30.3333H31C32.4667 30.3333 33.6667 29.1333 33.6667 27.6667V11.6667ZM31 11.6667L20.3333 18.3333L9.66667 11.6667H31ZM31 27.6667H9.66667V14.3333L20.3333 21L31 14.3333V27.6667Z",
    fill: "#2C6199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineEmail);
export default __webpack_public_path__ + "static/media/ic_outline-email.c100af76d698b0e62dbcfa3d97f2ff38.svg";
export { ForwardRef as ReactComponent };